import { VehicleType } from '../resources/base/models/vehicleTypes';

export interface VehicleConfigData {
  brand?: string;
  model?: string;
  modelGroup?: string;
  engine?: any;
  modelName?: string;
  modelDescription?: string;
  catalogPrice?: number;
  catalogPriceBto?: number;
  fiscalPower?: number;
  dinHp?: number;
  regDate?: string;
  regCost?: boolean;
  transformationSoc?: boolean;
  batteryPrice?: number;
  co2emision?: number | '';
  currMileage?: number | undefined;
  estDelivery?: any;
  department?: any;
  genreList?: string;
  resolution?: boolean;
  deliveryCost?: number;
  vehicleType?: VehicleType;
  isDemo?: boolean;
  licensePlate?: string;
  vin?: string;
  accessoires?: number;
  totalRegCost?: number;
  options?: number;
  freeOptionsBTO?: number;
  vehicleMilesId?: string;
  isRimSelected?: boolean;
  rims?: string;
}

export enum ConfigurationsSection {
  BASECONFIGURATION = 'Base configuration',
  ADDITIONALCONFIGURATION = 'Additional configuration',
}
